///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import { getEmployees } from "../../api/persons";
import AutoComplete from "../form-controls/AutoComplete";
import messages from "../../helpers/messages";

export const LaneAssignment = ({
  laneCount,
  regionName,
  totalLanes,
  regionId,
  onChange,
  assignedUser,
  edited,
  newUser
}) => {
  let width = (laneCount / totalLanes) * 80;
  width = width < 1 && width > 0 ? 1 : width;
  width = Math.round(width);

  let user = null;
  if (edited) {
    user = newUser ? { label: newUser.fullName, value: newUser.userid } : null;
  } else if (assignedUser) {
    user = { label: assignedUser.fullName, value: assignedUser.userId };
  }

  return (
    <div className="one-whole border-bottom-grey font-size-14">
      <div
        data-testid="region-name"
        className="grid__cell two-tenths pr-8 pt-12 mt-2 truncate"
      >
        {regionName}
      </div>
      <div style={{ width: 410 }} className="grid__cell pt-4">
        <div className="grid__cell complete" style={{ width: width + "%" }}>
          &nbsp;
        </div>
        <div data-testid="lane-count" className="grid__cell pl-16 pt-8 mt-2">
          {laneCount}
        </div>
      </div>
      <div
        style={{ width: 180 }}
        data-testid="assigned-to"
        className="grid__cell pt-4"
      >
        <AutoComplete
          value={user}
          handleOptionsMapping={options =>
            options.map(option => ({
              ...option,
              label: option.fullName,
              value: option.userId
            }))
          }
          fetchFrom={getEmployees}
          label={messages.name.defaultMessage}
          handleChange={selected => onChange(regionId, selected)}
        />
      </div>
    </div>
  );
};

export default LaneAssignment;
